module.exports = __webpack_public_path__ + "img/pharmaceutical.0cea7581.webp";